export default __webpack_public_path__ + "images/GXA.24985c2.png";